
import { Component, Prop, Vue, Mixins } from 'vue-property-decorator'
import { Statistic } from 'ant-design-vue'
import lodash from 'lodash'
import { MixinsCourseAgreement } from '@xt/client/mixins'
@Component({
  components: { AStatisticCountdown: Statistic.Countdown }
})
export default class PageView extends Mixins(MixinsCourseAgreement) {
  goCourseAgreement() {
    this.$router.push({
      name: 'agreement',
      query: { id: String(this.dataSource.original.productInfo.id) }
    })
  }
  created() {
    this.onLoad()
  }
  mounted() {}
  updated() {}
  destroyed() {}
}
